module.exports = "/_next/static/resources/array-ca891e2580ec16aebc8fd239b5817181.jpg";